import BigNumber from 'bignumber.js';

export const isNullOrEmpty = s => {
  return s === null || s === '';
};

export const isNullOrUndefined = s => {
  return [undefined, null, 'undefined', 'null'].includes(s);
};

export const isString = (str) => {
  return typeof str === 'string';
};
export const dateToString = (text, format, notReplace) => {
  if (isNullOrEmpty(text)) {
    return '';
  }
  if (!notReplace && isString(text)) {
    text = text.replace(/\.\d+/, '').replace(/-/g, '/');
  }
  const date = new Date(text);
  if (isNullOrEmpty(date) || isNaN(date.getDate())) {
    return '';
  }
  let dateStr = format;
  dateStr = dateStr
    .replace('yyyy', date.getFullYear())
    .replace('MM', (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1))
    .replace('dd', (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()))
    .replace('HH', (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()))
    .replace('mm', (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()))
    .replace('ss', (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()));
  dateStr = dateStr
    .replace('M', date.getMonth() + 1)
    .replace('d', date.getDate())
    .replace('H', date.getHours())
    .replace('m', date.getMinutes())
    .replace('s', date.getSeconds());
  return dateStr;
};

/**
 * 数字使用千分位分隔
 * @param {Number} number 需要格式化的数字
 * @param {Int} fixed 保留小数位数
 */
export const toThousands = (number, fixed) => {
  if (/^-?\d+(\.\d+)?$/.test(number)) { // 判断输入内容是否为整数或小数
    let n = Math.abs(number);
    if (typeof fixed !== 'undefined' && fixed > -1) {
      n = n.toFixed(fixed);
    }
    const reg = /\d{1,3}(?=(\d{3})+$)/g;
    const n1 = (n + '').replace(/^(\d+)((\.\d+)?)$/, function(s, s1, s2) { return s1.replace(reg, '$&,') + s2; });
    return (number < 0 ? '-' : '') + n1;
  } else {
    return '0';
  }
};

// 浮点数相乘
export const multipliedBy = (a = 0, b = 0) => {
  return (new BigNumber(a)).times(new BigNumber(b)).toNumber();
};
export function loadScript(src, allowOnlyOne) {
  loadScript._cachePromises = loadScript._cachePromises || {};
  const cachePromise = loadScript._cachePromises[src];
  // 若同一脚本 只允许加载一次 且 已有缓存
  if (allowOnlyOne && cachePromise) {
    return cachePromise;
  }

  const loadPromise = new window.Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = src;
    script.onload = () => resolve(true);
    script.onerror = () => {
      reject(false);

      // 加载失败，允许再次加载
      if (allowOnlyOne) {
        document.head.removeChild(script);
        delete loadScript._cachePromises[src];
      }
    };
    script.onreadystatechange = () => {
      if (
        script.readyState === 'loaded' ||
        script.readyState === 'complete'
      ) {
        resolve(true);
      }
    };
    // 默认 允许重复加载脚本
    if (!allowOnlyOne) {
      document.head.appendChild(script);
    } else {
      const scriptList = Array.from(
        document.head.querySelectorAll('script')
      );
      const isExists = scriptList.some(script => script.src === src);
      if (!isExists) {
        document.head.appendChild(script);
      } else {
        setTimeout(() => {
          resolve(true);
        }, 500);
      }
    }
  });

  loadScript._cachePromises[src] = loadPromise;

  return loadPromise;
}
